<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">How Montpelier Got Its Name: The Settlement of Montpelier and Place Name Origins</a></p>
<p class="toc2"><a href="#/chapter02">Chester Wright: Montpelier’s First Minister Describes the Moral Climate of the Early Days</a></p>
<p class="toc2"><span href="#/chapter03" title="Link target outside of Sample">Common Crackers: The Famous Vermont Common Cracker’s
 Origins in Montpelier</span></p>
<p class="toc2"><span href="#/chapter04" title="Link target outside of Sample">Sam Upham: Civil War Counterfeiter</span></p>
<p class="toc2"><span href="#/chapter05" title="Link target outside of Sample">Daniel Pierce Thompson: Montpelier’s First Historian and Great Eccentric</span></p>
<p class="toc2"><span href="#/chapter06" title="Link target outside of Sample">The Montpelier Fire: The Great Fire of 1875 Determined the Appearance of the City</span></p>
<p class="toc2"><span href="#/chapter07" title="Link target outside of Sample">The Lane Shops: Important Manufacturer of the Nineteenth Century</span></p>
<p class="toc2"><span href="#/chapter08" title="Link target outside of Sample">Joel Foster and the Waterworks: The New Water System Introduced after the Great Fire</span></p>
<p class="toc2"><span href="#/chapter09" title="Link target outside of Sample">Gould-Caswell Murder: The “Montpelier Murder” of 1889 Made National News</span></p>
<p class="toc2"><span href="#/chapter10" title="Link target outside of Sample">Black Agnes: John Hubbard’s Unquiet Grave</span></p>
<p class="toc2"><span href="#/chapter11" title="Link target outside of Sample">The Keeley Institute: Treating Substance Abuse at the Turn of the Century</span></p>
<p class="toc2"><span href="#/chapter12" title="Link target outside of Sample">Clang, Clang, Clang Went the Trolley: A Brief History of the Electric Railroad Between Barre and Montpelier</span></p>
<p class="toc2"><span href="#/chapter13" title="Link target outside of Sample">Emma Goldman and Montpelier’s Socialist Hall: Anarchists in the Capital City, circa 1905</span></p>
<p class="toc2"><span href="#/chapter14" title="Link target outside of Sample">Dorman B.E. Kent: Montpelier Historian and Humorist</span></p>
<p class="toc2"><span href="#/chapter15" title="Link target outside of Sample">Montpelier’s New Firehouse, 1924: The Consequences of a Tragic Fire</span></p>
<p class="toc2"><span href="#/chapter16" title="Link target outside of Sample">Mari Tomasi: The Montpelier Novelist Who Told Vermont’s “Italian Story”</span></p>
<p class="toc1"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?680abd34